module.exports = __webpack_public_path__ + "img/Group-51.e3050ef5.png";